import React, { useMemo, useState, useEffect } from "react";
import "../Programmes Page/ProgrammeFilters.css";
import { FaSearch } from "react-icons/fa";
import { programmes } from "../Tuition Fees/programmes";
import { allSchools, levelLabel, sortLevelLabels, sameLevel } from "../Programmes Page/filterRoutes";
import { fuzzyMatches } from "../lib/fuzzySearch";

const HeroFilterprog = ({ onFilter }) => {
  const [search, setSearch] = useState("");
  const [school, setSchool] = useState("");
  const [level, setLevel] = useState("");

  // Get unique schools
  const schools = useMemo(
    () => allSchools(),
    []
  );

  // Get unique programme levels
  const levels = useMemo(
    () => sortLevelLabels(programmes.map((p) => p.category)),
    []
  );

  useEffect(() => {
    if (!onFilter) return;

    const hasFilters =
      search.trim() !== "" ||
      school !== "" ||
      level !== "";

    // Nothing selected -> show blank page
    if (!hasFilters) {
      onFilter([], false);
      return;
    }

    const filtered = programmes.filter((programme) => {
      const matchesSearch = fuzzyMatches(
        [programme.title, programme.code, programme.school, programme.qualification, programme.keywords]
          .filter(Boolean)
          .join(" "),
        search
      );

      const matchesSchool =
        school === "" ||
        programme.school === school;

      const matchesLevel =
        level === "" ||
        sameLevel(programme.category, level);

      return (
        matchesSearch &&
        matchesSchool &&
        matchesLevel
      );
    });

    onFilter(filtered, true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, school, level]);

  const handleReset = () => {
    setSearch("");
    setSchool("");
    setLevel("");
    // No need to call onFilter here.
    // useEffect will automatically return the page to the blank state.
  };

  return (
    <section className="programme-filters programme-filters--flush">
      <div className="container">

        <div className="filters-card">

          <div className="filters-heading">
            <h2>Find Your Programme</h2>

            <p>
              Search programmes by keyword, school or study level.
            </p>
          </div>

          <div className="filters-grid">

            {/* Search */}
            <div className="filter-item search-box">
              <FaSearch className="search-icon" />

              <input
                type="text"
                placeholder="Search programmes..."
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
              />
            </div>

            {/* School */}
            <select
              value={school}
              onChange={(e) =>
                setSchool(e.target.value)
              }
            >
              <option value="">
                All Schools
              </option>

              {schools.map((item) => (
                <option
                  key={item}
                  value={item}
                >
                  {item}
                </option>
              ))}
            </select>

            {/* Level */}
            <select
              value={level}
              onChange={(e) =>
                setLevel(e.target.value)
              }
            >
              <option value="">
                All Levels
              </option>

              {levels.map((item) => (
                <option
                  key={item}
                  value={item}
                >
                  {levelLabel(item)}
                </option>
              ))}
            </select>

            {/* Reset */}
            <button
              type="button"
              className="reset-btn"
              onClick={handleReset}
            >
              Reset
            </button>

          </div>

        </div>

      </div>
    </section>
  );
};

export default HeroFilterprog;
